import React, { Component } from 'react';

class ParticipantModel extends Component {
    render() {
        const { participants } = this.props;

        return (
            <div className="ParticipantModel">
                <span className="table-title">Katılımcılar</span>
                <table className="table">
                    <thead>
                    <tr>
                        <th>Sıra No</th>
                        <th>Adı Soyadı</th>
                    </tr>
                    </thead>
                    <tbody>
                    {participants.map((participant, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{participant.ad + ' ' + participant.soyad}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ParticipantModel;



// WEBPACK FOOTER //
// ./src/page/odaList/ParticipantModel.js